module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo6-162a69a3e8d39669d6c2a5aa8fca1cf5.jpg";